import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IRouterProps } from '@interfaces/App.interface';
import {
  generateGlobalColumns,
  generateEntityColumn,
  generateMultiEntityColumn,
  TInheritedProps,
  IDataGridConfig,
} from '@ts/storybook';
import { useAppSelector } from '@redux/store';
import { CEntity, CEventType, CCategory, IConfigComponent } from '@ts/ui-models';

interface IEventTypesProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
  title?: string;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'eventTypes',
  aclId: 'taEventType',
  entity: 'eventType',
  fetchURL: '/api/eventTypes',
  crudURL: '/api/eventType',
  mainClass: CEventType,
};

const EventTypes = (props: IEventTypesProps) => {
  const { title, configComponent = defaultConfigComponent, inheritedProps } = props;
  const eventTypes = useAppSelector(state => state.global.eventsTypesList);

  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };
  const getColumns = useMemo((): GridColDef[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      globalCells.name(),
      generateMultiEntityColumn(
        { field: 'categories', headerName: 'Categories' },
        { field: 'categories', mainClass: CCategory },
        { inheritedProps, chips: { limitChips: 5, onlyChips: true } }
      ),
      generateEntityColumn(
        { field: 'newLocation', headerName: 'New location for the item' },
        { field: 'newLocation', mainClass: CEntity },
        { inheritedProps }
      ),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      title={title}
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      rows={{ count: eventTypes.length, rows: eventTypes }}
      dataGridMode={eventTypes.length > 0 ? 'client' : 'server'}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default EventTypes;
